import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

// ----------------------------------------------------------------------
const initialConditionValueObj = {
  term: '',
  valueToPass: '',
};
// ----------------------------------------------------------------------
const initialConditionValue = [initialConditionValueObj];
// ----------------------------------------------------------------------

export const QuizContext = createContext({});

export const QuizProvider = ({ children }) => {
  const [conditions, setConditions] = useState(initialConditionValue);
  const [tags, setTags] = useState([]);
  const [content, setContent] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bannersHash, setBannersHash] = useState([]);
  const [serverBanners, setServerBanners] = useState([]);
  const [achievementIncludes, setAchievementIncludes] = useState([]);
  const [gender, setGender] = useState(1);
  const [minCoin, setMinCoin] = useState(0);
  const [minLife, setMinLife] = useState(0);
  const [lifeCount, setLifeCount] = useState(0);
  const [minBalance, setMinBalance] = useState(0);
  const [preview, setPreview] = useState(false);
  const [tagsActive, setTagsActive] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [genderActive, setGenderActive] = useState(false);
  const [commentStatus, setCommentStatus] = useState(false);
  const [minCoinActive, setMinCoinActive] = useState(false);
  const [minLifeActive, setMinLifeActive] = useState(false);
  const [minBalanceActive, setMinBalanceActive] = useState(false);
  const [ageRestrictActive, setAgeRestrictActive] = useState(false);
  const [achievementIncludesActive, setAchievementIncludesActive] = useState(false);
  const [type, setType] = useState('');
  const [text, setText] = useState('');
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('');
  const [amount, setAmount] = useState('');
  const [quizID, setQuizID] = useState('');
  const [passCode, setPassCode] = useState('');
  const [streamKey, setStreamKey] = useState('');
  const [categoryID, setCategoryID] = useState('');
  const [rewardType, setRewardType] = useState('');
  const [description, setDescription] = useState('');
  const [ageRestrict, setAgeRestrict] = useState('');
  const [shortDescription, setShortDescription] = useState('');
  const [endAt, setEndAt] = useState(null);
  const [startAt, setStartAt] = useState(null);
  const [expiresAt, setExpiresAt] = useState(null);

  const clean = () => {
    setTags([]);
    setContent([]);
    setBanners([]);
    setConditions(initialConditionValue);
    setBannersHash([]);
    setServerBanners([]);
    setAchievementIncludes([]);
    setGender(1);
    setMinCoin(0);
    setMinLife(0);
    setLifeCount(0);
    setMinBalance(0);
    setPreview(false);
    setTagsActive(false);
    setIsSubmitting(false);
    setGenderActive(false);
    setCommentStatus(false);
    setMinCoinActive(false);
    setMinLifeActive(false);
    setMinBalanceActive(false);
    setAgeRestrictActive(false);
    setAchievementIncludesActive(false);
    setType('');
    setText('');
    setTitle('');
    setStatus('');
    setAmount('');
    setQuizID('');
    setPassCode('');
    setStreamKey('');
    setCategoryID('');
    setRewardType('');
    setDescription('');
    setAgeRestrict('');
    setShortDescription('');
    setEndAt(null);
    setStartAt(null);
    setExpiresAt(null);
  };

  return (
    <QuizContext.Provider
      value={{
        serverBanners,
        setServerBanners,
        quizID,
        setQuizID,
        bannersHash,
        setBannersHash,
        content,
        setContent,
        achievementIncludes,
        setAchievementIncludes,
        setAchievementIncludesActive,
        achievementIncludesActive,
        setMinBalance,
        minBalance,
        banners,
        setBanners,
        title,
        setTitle,
        shortDescription,
        setShortDescription,
        description,
        setDescription,
        lifeCount,
        setLifeCount,
        streamKey,
        setStreamKey,
        rewardType,
        setRewardType,
        amount,
        setAmount,
        text,
        setText,
        startAt,
        setStartAt,
        expiresAt,
        setExpiresAt,
        endAt,
        setEndAt,
        passCode,
        setPassCode,
        status,
        setStatus,
        commentStatus,
        setCommentStatus,
        isSubmitting,
        setIsSubmitting,
        type,
        setType,
        categoryID,
        setCategoryID,
        conditions,
        setConditions,
        preview,
        setPreview,
        minCoinActive,
        setMinCoinActive,
        minCoin,
        setMinCoin,
        tagsActive,
        setTagsActive,
        tags,
        setTags,
        ageRestrictActive,
        setAgeRestrictActive,
        ageRestrict,
        setAgeRestrict,
        genderActive,
        setGenderActive,
        gender,
        setGender,
        minLifeActive,
        setMinLifeActive,
        minLife,
        setMinLife,
        minBalanceActive,
        setMinBalanceActive,
        clean,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};

QuizProvider.propTypes = {
  children: PropTypes.node,
};
